/**
 * Counts emoji characters in a string.
 *
 * `\p{Extended_Pictographic}` is the Unicode property used to identify emoji-like
 * codepoints — it covers the standard emoji set (faces, symbols, objects, flags,
 * skin-tone modifiers, etc.) without needing an emoji-data package. Requires the
 * `u` flag; supported natively in all modern JS engines (no polyfill/transpile
 * needed for evergreen browsers).
 */
export const countEmojis = (text) => {
  if (!text) return 0;
  const matches = text.match(/\p{Extended_Pictographic}/gu);
  return matches ? matches.length : 0;
};
